import { useEffect } from "react";

const useProcessGeoData = (fetchedData, isLoaded, setPolygonPaths) => {
  useEffect(() => {
    if (!isLoaded) return;
    const parsedPolygons = [];
    fetchedData.forEach((item) => {
      const boundaries = item?.boundaries || [];

        if (!boundaries?.type || !boundaries?.coordinates) return;
        let coordinateGroups = [];

        if (boundaries.type === "Polygon") {
          coordinateGroups = [boundaries.coordinates[0]];
        } else if (boundaries.type === "MultiPolygon") {
          coordinateGroups = boundaries.coordinates.map((poly) => poly[0]);
        }

        coordinateGroups.forEach((coords) => {
          parsedPolygons.push({
            constituencyId: item?._id || "",
            coordinate: coords.map((coord) => ({
              lat: coord[1],
              lng: coord[0],
            })),
            name: item?.name || "",
            state: item?.state || "",
            district: item?.district || "",
          });
        })
    });
    setPolygonPaths(parsedPolygons);
  }, [fetchedData, isLoaded, setPolygonPaths]);
};

export default useProcessGeoData;
